'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _subscriptions = require('redux/modules/subscriptions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelSubscriptionDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    cancelling: state.subscriptions.cancelling,
    cancelled: state.subscriptions.cancelled,
    cancelError: state.subscriptions.cancelError
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(CancelSubscriptionDialog, _React$Component);

  function CancelSubscriptionDialog() {
    (0, _classCallCheck3.default)(this, CancelSubscriptionDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CancelSubscriptionDialog.__proto__ || (0, _getPrototypeOf2.default)(CancelSubscriptionDialog)).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(CancelSubscriptionDialog, [{
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      if (this.props.reporting) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: 'onCancelSubscriptionClick',
    value: function onCancelSubscriptionClick(e) {
      this.props.dispatch((0, _subscriptions.cancelSubscription)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./CancelSubscriptionDialog.scss');
      var _props = this.props,
          cancelling = _props.cancelling,
          cancelled = _props.cancelled,
          cancelError = _props.cancelError,
          disableAutoRenew = _props.disableAutoRenew;
      var expiresAt = this.props.subscription.expiresAt;


      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.CancelSubscriptionDialog, true), (0, _defineProperty3.default)(_classnames, styles['CancelSubscriptionDialog--error'], this.state.error), _classnames));

      return _react2.default.createElement(
        _components.PopupBox,
        { className: styles.Popup__Override },
        _react2.default.createElement(
          'div',
          { className: styles['CancelSubscriptionDialog__options'] },
          cancelling && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.LoadingIndicator, { className: styles['CancelSubscriptionDialog__loading-indicator'] })
          ),
          !cancelled && !cancelling && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h2',
              null,
              'Are you sure?'
            ),
            _react2.default.createElement(
              'div',
              { className: styles['CancelSubscriptionDialog__note'] },
              _react2.default.createElement(
                'p',
                null,
                'We are sorry to see you go!'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                'Cancelling your subscription means your access to Megascans will be limited after the next billing date. This means you will always be able to get your previously downloaded scans, however an active subscription will be required to use Quixel Mixer or to download any new scans. Accumulated points will always be saved in your account. You can, at any time, resubscribe to continue using Megascans.'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                'You will be able to download new scans uptil ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)(expiresAt).format('MMMM DD, YYYY')
                ),
                '.'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                'With tons of new content pouring in shortly, we hope to see you again very soon! '
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Note:'
                ),
                ' If you choose to keep subscribing, your unused points will keep accumulating and can be used at any time.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles['col-md-12'] },
              _react2.default.createElement(
                'div',
                { className: styles['CancelSubscriptionDialog__buttons'] },
                _react2.default.createElement(_components.Button, { alternative: true, label: 'Yes, revoke my subscription', onClick: this.onCancelSubscriptionClick.bind(this) })
              ),
              _react2.default.createElement(
                'div',
                { className: styles['CancelSubscriptionDialog__buttons'] },
                _react2.default.createElement(_components.Button, { primary: true, label: 'No, keep points and licenses', onClick: this.handleCancelClick.bind(this) })
              )
            )
          ),
          cancelled && !cancelling && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h2',
              null,
              'You have been unsubscribed.'
            ),
            _react2.default.createElement(
              'div',
              { className: styles['CancelSubscriptionDialog__message'] },
              _react2.default.createElement(
                'p',
                null,
                'You will be able to download Megascans uptil ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)(expiresAt).format('MMMM DD, YYYY')
                ),
                '.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles['col-md-12'] },
              _react2.default.createElement(
                'div',
                { className: styles['CancelSubscriptionDialog__buttons'] },
                _react2.default.createElement(_components.Button, { primary: true, label: 'Close', onClick: this.handleCancelClick.bind(this) })
              )
            )
          )
        )
      );
    }
  }]);
  return CancelSubscriptionDialog;
}(_react2.default.Component)) || _class);
exports.default = CancelSubscriptionDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CancelSubscriptionDialog/CancelSubscriptionDialog.jsx
// module id = 2689
// module chunks = 0